import { IVideoStreamModel } from './interfaces';

export const videoStreamSelectors = {
    getReady: (state: IVideoStreamModel) => state.ready,

    getQualities: (state: IVideoStreamModel) => Object.entries(state.qualities || {}),

    getStatus: (gui: boolean) => (state: IVideoStreamModel) => {
        if (gui) {
            return 'Off';
        }

        if (state.selectedQuality) {
            return state.selectedQuality;
        }

        const videoQualitiesEntries = Object.entries(state.qualities || {});

        if (!videoQualitiesEntries.length) {
            return 'On';
        }

        // Optional chaining for CCTV video which doesn't have qualities set and isActive property
        return videoQualitiesEntries.find(([, data]) => data.isActive)?.[0];
    },

    getPlaying: (state: IVideoStreamModel) => state.playing,

    getStartTime: (state: IVideoStreamModel) => state.startTime,

    getTimeToReady: (state: IVideoStreamModel) => state.timeToReady,
};
